// MENTOR_FETCH is not defined because we don't want to fetch the own mentor data, it's being 
// handled by the user module (user response contains mentor data in user.mentor)
// MENTOR_FETCH_SUCCEEDED is used to update the mentor data in the store after receiving the user
const MENTOR_FETCH_SUCCEEDED = 'bfb/mentor/MENTOR_FETCH_SUCCEEDED';
const MENTOR_FETCH_FAILED = 'bfb/mentor/MENTOR_FETCH_FAILED';
const MENTOR_EDIT = 'bfb/mentor/MENTOR_EDIT';
const MENTOR_EDIT_SUCCEEDED = 'bfb/mentor/MENTOR_EDIT_SUCCEEDED';
const MENTOR_EDIT_FAILED = 'bfb/mentor/MENTOR_EDIT_FAILED';

const MENTOR_SELECTED_FETCH = 'bfb/mentor/MENTOR_SELECTED_FETCH';
const MENTOR_SELECTED_FETCH_SUCCEEDED = 'bfb/mentor/MENTOR_SELECTED_FETCH_SUCCEEDED';
const MENTOR_SELECTED_FETCH_FAILED = 'bfb/mentor/MENTOR_SELECTED_FETCH_FAILED';

export default {
  MENTOR_FETCH_SUCCEEDED,
  MENTOR_FETCH_FAILED,
  MENTOR_EDIT,
  MENTOR_EDIT_SUCCEEDED,
  MENTOR_EDIT_FAILED,
  MENTOR_SELECTED_FETCH,
  MENTOR_SELECTED_FETCH_SUCCEEDED,
  MENTOR_SELECTED_FETCH_FAILED,
};
